export enum SelectorType {
  post = 'post',
  comment = 'comment',
}

export type Profile = {
  type: string;
  name: string;
  isSelected: boolean;
  slug: string;
  fullName: string;
  avatarURL: string | null;
  active: boolean;
};
